export const useTelegramWebApp = function () {
    return useNuxtApp().$telegramWebApp;
};